import React, { useState, useEffect, useContext } from "react";
import Request from "common/Request";
import ActionsContext from "common/ActionsContext";
import styled from "styled-components";
import Table from "common/MuiTable";

const TableContainer = styled.div`
  width: 100%;
  overflow: auto;

  .dataTables_info,
  .dataTables_paginate,
  .dataTables_filter,
  .dataTables_length {
    display: none;
  }
`;

const LicenseReport = () => {
  const actions = useContext(ActionsContext);
  const [request, setRequest] = useState(null);
  const [tableData, setTableData] = useState();

  const getLicense = () => {
    ifCl.run(`show license`).then((response) => {
      const [header, ...rows] = response.trim(/\s/).split("\n");
      const headerAttrs = header.trim(/\s/).split(/\s+/);
      const indexHeaderMap = headerAttrs.reduce((acc, value, index) => {
        acc[index] = value;
        return acc;
      }, {});
      const tableRows = rows.reduce((acc, row) => {
        const rowAttrs = row.trim(/\s/).split(/\s+/);
        const tableRow = rowAttrs.reduce((accRow, attr, index) => {
          if(indexHeaderMap[index]==="EXPIRATION"){
            if(attr==="n/a"){
             accRow[indexHeaderMap[index]] = "unlimited"; 
            } else {
              accRow[indexHeaderMap[index]] = attr;
            }
          } else {
            accRow[indexHeaderMap[index]] = attr;
          }
          return accRow;
        }, {});
        acc.push(tableRow);
        return acc;
      }, []);
      setTableData(tableRows);
    });
  };

  const columns = [
    {
      label: "FEATURE",
      id: "FEATURE",
      type: "Text",
    },
    {
      label: "EXPIRATION",
      id: "EXPIRATION",
      type: "Text",
    },
    {
      label: "CAPACITY",
      id: "USAGE-MAX",
      type: "Text",
    },
    {
      label: "VALID",
      id: "VALID",
      type: "Text",
    },
    {
      label: "STATIC",
      id: "STATIC",
      type: "Text",
    },
  ];

  const doLoad = () => {
    setRequest(getLicense());
  };

  useEffect(() => {
    doLoad();

    return actions.recv("do-load", doLoad);
  }, []);

  return (
    <>
      <TableContainer>
        <Table columns={columns} rows={tableData} exportCSV={false} />
      </TableContainer>
    </>
  );
};

export default LicenseReport;




